import { DEFAULT_ICONS } from '@/ui/theme/icons';
import { zodEnumFromObjKeys } from '@/zod/helpers';

export const iconSchema = zodEnumFromObjKeys(DEFAULT_ICONS).catch('BULLET');
